// @flow
import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line import/named
import { type IntlShape } from 'react-intl';

// Components
import { Container } from 'reactstrap';
import Button from 'components/atoms/Button';

// Utils
import { formatPhoneNumber } from 'utils/string';

import './InfoPanel.scss';

const ns = 'info-panel';

type Props = {
  contactInfo: Object,
  dealerCountryCode: string,
  showEditButton: boolean,
  onClick?: () => void,
  intl: IntlShape,
  isRegistrationNumEnabled: boolean,
  ariaGroupLabel: object
};

const InfoPanel = ({
  contactInfo,
  dealerCountryCode,
  showEditButton,
  onClick,
  intl,
  isRegistrationNumEnabled,
  ariaGroupLabel
}: Props) => {
  const { name, firstName, lastName, phone, phoneNo, email } = contactInfo;
  const completeName = firstName
    ? `${firstName} ${lastName}`
    : lastName || name;
  const phoneNumber = (phone || phoneNo || '').toString();
  const emailClassName = classNames([`${ns}__info-email notranslate`], {
    'mb-0': isRegistrationNumEnabled
  });
  const phoneNumberFormatted = formatPhoneNumber(
    phoneNumber || '',
    dealerCountryCode
  );
  return (
    <Container
      className={`${ns}__info`}
      role={'group'}
      aria-label={ariaGroupLabel ? intl.formatMessage(ariaGroupLabel) : ''}
    >
      <p className={`${ns}__info-name notranslate`}>{completeName}</p>
      <p x-ms-format-detection="none" className={`${ns}__info-phone`}>
        {!!phoneNumberFormatted && (
          <a
            href={`tel:${phoneNumberFormatted}`}
            target="_parent"
            title={intl.formatMessage({
              id: 'c8.aria.phone.number',
              defaultMessage: 'Phone number'
            })}
          >
            {phoneNumberFormatted}
          </a>
        )}
      </p>
      {email && <p className={emailClassName}>{email}</p>}

      {showEditButton &&
        onClick && (
          <Button
            className={`${ns}__info-edit`}
            buttonTheme="link"
            onClick={e => onClick()}
          >
            {intl.formatMessage({
              id: 'c8.review.edit'
            })}
          </Button>
        )}
    </Container>
  );
};

InfoPanel.defaultProps = {
  contactInfo: {},
  ariaGroupLabel: null
};

export default InfoPanel;



// WEBPACK FOOTER //
// ./src/components/atoms/InfoPanel/InfoPanel.js